import {css} from 'emotion';

// Single source of truth for gradient colors
export const gradientColors = {
  position0: '#00CDF6',
  position25: '#1088EB',
  position50: '#1F3CD7',
  position100: '#691C9C',
};

export const fullGradientColors = {
  position0: {
    color: gradientColors.position0,
  },
  position25: {
    color: gradientColors.position25,
  },
  position50: {
    color: gradientColors.position50,
  },
  position100: {
    color: gradientColors.position100,
  },
};

export const partialGradientColors = {
  position0: {
    color: gradientColors.position25, // Using position25 as start for partial
  },
  position25: {
    color: gradientColors.position50,
  },
  position100: {
    color: gradientColors.position100,
  },
};

// Utility function to create full gradient backgrounds with different opacity overlays
const createFullGradientBackground = (opacity) => {
  return `linear-gradient(to right, rgba(255, 255, 255, ${opacity}), rgba(255, 255, 255, ${opacity})), linear-gradient(97deg, ${gradientColors.position0} 0%, ${gradientColors.position25} 25%, ${gradientColors.position50} 50%, ${gradientColors.position100} 100%)`;
};

// Gradient background system matching Figma naming conventions
export const gradientBackgrounds = {
  100: createFullGradientBackground(0.9),
};

export const partialLinearGradient = `linear-gradient(279deg, ${partialGradientColors.position100.color} 0%, ${partialGradientColors.position25.color} 65%, ${partialGradientColors.position0.color} 100%)`;

export const partialCtaDefaultLinearGradientBackground = {
  background: partialLinearGradient,
};

export const buttonWithPopOutRootCss = css({
  display: 'block',
  '&:hover': {
    path: {
      stroke: 'none',
    },
  },
});

export const buttonIconContainerCss = css({
  borderRadius: '10px',
  padding: '1px',
  ...partialCtaDefaultLinearGradientBackground,
});

export const buttonIconBorderCss = css({
  borderRadius: '10px',
  padding: '6px 8px',

  background: gradientBackgrounds[100],
});

export const searchToggleButtonSvgCss = {
  width: '28px',
  height: '28px',
};

export const popOutCss = css({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
});
